var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { CommunicationService } from '../../services/communication.service';
import { ListingCategory, MyRemaxModes, SCREEN_SIZE, ViewModes } from '../../classes/enums';
import { HasSubscriptions } from '../has-subscriptions';
import { ListingsService } from '../../services/listings.service';
import { PositionInfo, Filters } from '../../classes/user-preferences';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PreferencesService } from '../../services/preferences.service';
import { PinInfo } from '../../classes/pin-info';
import { CacheService } from '../../services/cache.service';
import { PreRenderService } from '../../services/pre-render.service';
import { GoogleMapsService } from '../../services/google-maps.service';
import { MetaTagService } from '../../services/meta-tag.service';
import { DomManipulationService } from '../../services/dom-manipulation/dom-manipulation.service';
import { Pagination } from '../../classes/pagination';
import { LoggerService } from '../../services/logger/logger.service';
import { of, forkJoin } from 'rxjs';
import { debounceTime, switchMap, filter, take, takeWhile } from 'rxjs/operators';
import { PersonaType } from '../../classes/enums';
import { InternalLinksService } from '../../services/internalLinks.service';
var HomePageComponent = /** @class */ (function (_super) {
    __extends(HomePageComponent, _super);
    function HomePageComponent(communicationService, listingsService, translateService, userService, preferencesService, cache, activatedRoute, prerenderService, router, googleService, metaTagsService, domManipulationService, logger, internalLinksService) {
        var _this = _super.call(this) || this;
        _this.communicationService = communicationService;
        _this.listingsService = listingsService;
        _this.translateService = translateService;
        _this.userService = userService;
        _this.preferencesService = preferencesService;
        _this.cache = cache;
        _this.activatedRoute = activatedRoute;
        _this.prerenderService = prerenderService;
        _this.router = router;
        _this.googleService = googleService;
        _this.metaTagsService = metaTagsService;
        _this.domManipulationService = domManipulationService;
        _this.logger = logger;
        _this.internalLinksService = internalLinksService;
        _this.mapEnabled = true;
        // Holds the timestamp the last listing request was made.
        _this.globalListingRequestTimestamp = 0;
        _this.previewedListings = [];
        _this.skipNextListingSearch = false;
        _this.isSearchingPhysicalLocation = false;
        _this.isSuccessfulPhysicalLocation = false;
        _this.isShowingSavedSearch = false;
        _this.shouldShowSavedSearchModal = false;
        _this.showSaveSearchModal = false;
        _this.showNoSavedSearchFound = false;
        _this.isDoneFetchingListings = false;
        _this.isDoneFetchingSavedSearch = false;
        // When we're trying to access a specific page of the results via the queryParams ex: /?page=2
        _this.startingPageNumber = 0;
        _this.provinces = ['ab', 'nu', 'bc', 'on', 'mb', 'pe', 'nb', 'qc', 'nl', 'sk', 'nt', 'yt', 'ns'];
        // enums:
        _this.ViewModes = ViewModes;
        _this.SCREEN_SIZE = SCREEN_SIZE;
        _this.ListingCategory = ListingCategory;
        // Because of how often the listings change, we only want to check the first time for schema purposes
        _this.hasCheckedForAggregateOffers = false;
        _this.productSchema = [];
        _this.savedSearch = null;
        _this.prerenderService.setPreRenderFlag(200);
        _this.mapEnabled = !_this.prerenderService.isServerMode && !_this.userService.isGoogleBot();
        _this.addSub(_this.activatedRoute.data.subscribe(function (data) {
            _this.setContext(data);
        }));
        return _this;
    }
    HomePageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.topHeightOffset = this.domManipulationService.documentQuerySelectorHeight('.navbar-header') + 72;
        this.screenSize = this.communicationService.screenSize.getValue();
        this.addSub(this.preferencesService.viewModesChanged.subscribe(function (mode) { return _this.activeViewMode = mode; }));
        this.addSub(this.userService.currentUser.subscribe(function (user) {
            // Clear their application browsing history whenever we're on the map.
            if (user)
                user.session.resetHistory();
        }));
        this.addSub(this.preferencesService.positionInfoChanged.subscribe(function (positionInfo) { return _this._userPositionInfo = positionInfo; }));
        this.addSub(this.communicationService.searchParametersChanged
            .pipe(debounceTime(100), filter(function () {
            /* Only get more listings if:
             1: if we're done waiting for the user's location or We're on gallery view
             2: map bounds are defined
            */
            if (((!_this.isSearchingPhysicalLocation && !_this.skipNextListingSearch) || _this.activeViewMode === ViewModes.GALLERY)
                && (!_this.mapEnabled || _this._userPositionInfo.north)) {
                return true;
            }
            else {
                _this.skipNextListingSearch = false;
                return false;
            }
        }), switchMap(function () { return _this._getNewListingsSearch(); })) // Cancels any pending requests and fires a new request
            .subscribe(function (res) {
            // Since the map has changed, the saved search is not in use
            if (_this.isShowingSavedSearch) {
                _this.isShowingSavedSearch = false;
                _this.communicationService.selectedSaveSearch.next(null);
            }
            _this._handleNewListingsSearch(res);
            // If there are any saved searches after everything has been loaded, load the coordinates
            if (_this.savedSearch) {
                _this.updatedMapWithSavedSearch(_this.activatedRoute.snapshot.data.savedSearch);
            }
        }));
        this.addSub(this.preferencesService.doneGettingPhysicalLocation.subscribe(function (status) {
            // Don't bother running this if we already have a physical location.
            _this.isSearchingPhysicalLocation = !status[0];
            // Whenever we're finished trying to get the physical location (or skip it for Gallery), update the listings.
            if (status[0] || _this.activeViewMode === ViewModes.GALLERY) {
                _this.isSearchingPhysicalLocation = false;
                _this.isSuccessfulPhysicalLocation = status[1];
                _this.communicationService.searchParametersChanged.next();
            }
        }));
        this.hasSeenIntroAnimation = this.cache.get(this.cache.KeySeenIntroAnimation);
        this.addSub(this.communicationService.selectedSaveSearch.subscribe(function (s) { return _this.isShowingSavedSearch = !!s; }));
        this.addSub(this.communicationService.screenSize.subscribe(function (screenSize) { return _this.screenSize = screenSize; }));
        this.addSub(this.communicationService.listings.currentShownListingType.subscribe(function (s) {
            // On init, we don't want to actually trigger a new listing search, but we DO want to set the listingType.
            if (_this.currentShownListingType) {
                _this.communicationService.searchParametersChanged.next();
            }
            _this.currentShownListingType = s;
            // We only set this if its not a persona page
            if (_this.personaType === undefined && !_this.city) {
                var key = 'find-real-estate-';
                if (s === ListingCategory.RESIDENTIAL)
                    key += 'residential';
                else if (s === ListingCategory.COMMERCIAL)
                    key += 'commercial';
                else
                    key += 'luxury';
                _this._setSEORelatedItems(key, {});
            }
        }));
        this.addSub(this.activatedRoute.queryParams.subscribe(function (q) {
            // TODO: If there are query params that actually affect this page added, they should be checked to see if they changed
            // and Not set this flag until new data is loaded.
            _this.prerenderService.setPreRenderFlag(200);
        }));
        this.getFooterLinks();
        this.communicationService.footerLinksChange.next({ city: this.city, province: this.province });
    };
    HomePageComponent.prototype.updatedMapWithSavedSearch = function (s) {
        var _this = this;
        // once map updated, force update the position on map
        this.communicationService.searching.updateMap
            .pipe(takeWhile(function () { return !_this.isDoneFetchingSavedSearch; }))
            .subscribe(function (location) {
            if (location && location.location === s.positionInfo.centerLatLng && location.zoom === s.positionInfo.zoomLevel) {
                _this.preferencesService.setPosition(s.positionInfo.physicalLocation.lat, s.positionInfo.physicalLocation.lng, s.positionInfo.zoomLevel);
                _this.isDoneFetchingSavedSearch = true;
                // update savedsearch
                _this.savedSearch = null;
            }
        });
        // force update the map
        if (s.positionInfo && !this.isDoneFetchingSavedSearch) {
            this.communicationService.searching.updateMap.next({ location: PositionInfo.getCenter(s.positionInfo), zoom: s.positionInfo.zoomLevel });
        }
    };
    HomePageComponent.prototype.onViewModeClick = function (flipPage) {
        if (flipPage === void 0) { flipPage = true; }
        var newMode = ViewModes.MAP;
        if (this.activeViewMode === ViewModes.MAP) {
            newMode = ViewModes.GALLERY;
            this.communicationService.footerLinksChange.next({ city: this.city, province: this.province });
        }
        this.preferencesService.setViewModes(newMode);
        if (flipPage) {
            this.communicationService.flipPage.next();
        }
        this.communicationService.searchParametersChanged.next();
    };
    HomePageComponent.prototype.onSaveSearchClick = function () {
        this.communicationService.toolbar.saveSearchRequested.next();
    };
    HomePageComponent.prototype.onFilterClick = function () {
        this.communicationService.toolbar.filtersRequested.next();
    };
    HomePageComponent.prototype.goToSavedSearches = function ($event) {
        $event.preventDefault();
        this.router.navigate(['/my-remax'], { queryParams: { mode: MyRemaxModes.SAVED_SEARCHES } });
    };
    HomePageComponent.prototype.announceItemClicked = function (listings) {
        this.previewedListings = listings;
        this.communicationService.listings.listingsClicked.next(listings);
    };
    HomePageComponent.prototype.onPinsClicked = function (event) {
        // Update the list of previews to whatever's passed in.
        // In desktop, this will be the listings in a cluster, or the listings visible on the map.
        // In mobile, this will be the listings in a cluster, or a specific listing.
        // check if we have a previously selected cluster to display
        var previouslySelectedListingIds = this.cache.get(this.cache.KeyPreviouslySelectedListingIds);
        this.sideGalleryPins = previouslySelectedListingIds ?
            event.markers.filter(function (it) { return previouslySelectedListingIds.listingIds.indexOf(it.listingId) >= 0; }).map(function (m) { return new PinInfo({ listingId: m.listingId, listPrice: m.listPrice, listingDate: new Date(m.listingDate) }); }) :
            event.markers.map(function (m) { return new PinInfo({ listingId: m.listingId, listPrice: m.listPrice, listingDate: new Date(m.listingDate) }); });
        this.highlightedListing = event.selectedListingId;
    };
    HomePageComponent.prototype.hideSearchPopup = function () {
        this.showSaveSearchModal = false;
    };
    /**
     * Stuff we need to do if we come in from a popular city page: ex: /on/toronto-real-estate or a popular city prop page: /ex/on/toronto-condos-for-sale
     * Update the SEO Related Items (h1 tag, description, title)
     * Update the map so that we won't update the position to the user's position and instead use the location of the city
     * Also handles Open House Pages
     * Reset and Update Filters with correct prop type if necessary
     * @param resolverData Data from the Resolver
     */
    HomePageComponent.prototype._handlePopularCityAndPropPages = function (resolverData) {
        var _this = this;
        this.city = resolverData.city;
        this.province = resolverData.province;
        var totalListings = resolverData.totalListings;
        this.startingPageNumber = resolverData.pageNumber || 0;
        var propType = resolverData.propType;
        var isOpenHouse = !!resolverData.isOpenHouse;
        var isBusinessOpportunity = !!resolverData.isBusinessOpportunity;
        var searchString = "" + (this.city ? this.city.charAt(0).toUpperCase() + this.city.slice(1) : "") + (this.province ? " " + this.province.toUpperCase() : "");
        if (this.mapEnabled) {
            // On browser use google
            this.googleService.performGeocode(searchString).then(function (results) {
                if (results) {
                    /**
                     * In the situation where we have to explicitly set a location we need to do the following:
                     * 1) Change the placeholder text in the search bar to reflect the place being looked for
                     * 2) Changed the map position to be the specific search location
                     * 3) Prevent the map from recentering at the user position on further navigations to the home page
                     */
                    var geometry = results[0].geometry;
                    _this.communicationService.searching.activeSearchText.next(searchString);
                    _this._userPositionInfo.centerLatLng = geometry.location.toJSON();
                    // We need to explicitly save the bounds since the gallery will be using these bounds for searching
                    if (geometry && geometry.bounds) {
                        _this._userPositionInfo.north = geometry.bounds.getNorthEast().lat();
                        _this._userPositionInfo.east = geometry.bounds.getNorthEast().lng();
                        _this._userPositionInfo.south = geometry.bounds.getSouthWest().lat();
                        _this._userPositionInfo.west = geometry.bounds.getSouthWest().lng();
                        _this.preferencesService.setPosition(_this._userPositionInfo.centerLatLng.lat, _this._userPositionInfo.centerLatLng.lng, 11, geometry.bounds.getSouthWest().lat(), geometry.bounds.getSouthWest().lng(), geometry.bounds.getNorthEast().lat(), geometry.bounds.getNorthEast().lng());
                        _this.communicationService.searchParametersChanged.next();
                    }
                    else {
                        _this.preferencesService.saveUserPosition(_this._userPositionInfo);
                    }
                    _this.communicationService.searching.updateMap.next({ location: results[0].geometry.location.toJSON(), types: results[0].types });
                    _this.communicationService.searching.shouldCenterAtUserLocation.next(false);
                    _this.preferencesService.centerMapAtCurrentLocation(true);
                    // Update MetaTags
                    _this.updateCityPagesMetaItems(propType, totalListings, isOpenHouse);
                }
                else {
                    console.error('couldnt find their location');
                    _this.communicationService.searching.shouldCenterAtUserLocation.next(false);
                    _this.preferencesService.centerMapAtCurrentLocation(true);
                }
            });
        }
        else {
            this.logger.logDebug('homePageComponent', 'Rending listings for city', this.city, 'prop type', propType);
            this.activeViewMode = ViewModes.GALLERY;
            // The below call will trigger a chain that ends in searching listings.
            this.preferencesService.centerMapAtCurrentLocation(true);
            this.updateCityPagesMetaItems(propType, totalListings, isOpenHouse);
        }
        var propTypeSingular = null;
        if (propType) {
            // For our filters, we use the singular word instead of the pluralized
            propTypeSingular = propType[propType.length - 1] === 's' ? propType.slice(0, propType.length - 1) : propType;
        }
        if (this.mapEnabled) {
            // Normal flow of updating filters
            if (propTypeSingular) {
                // Reset the filters and update the prop type
                this.communicationService.filters.resetAndUpdatePropType.next(propTypeSingular);
            }
            this.preferencesService.filtersChanged.pipe(take(1)).toPromise().then(function (filters) {
                filters.hasOpenHouse = isOpenHouse;
                filters.listingTypes.businessOpportunity = isBusinessOpportunity;
                _this.preferencesService.updateFilters(filters);
            });
        }
        else {
            // Immediately update filters
            var newFilters = new Filters();
            newFilters.listingTypes = {};
            if (propTypeSingular) {
                newFilters.listingTypes[propTypeSingular] = true;
            }
            newFilters.hasOpenHouse = isOpenHouse;
            newFilters.listingTypes.businessOpportunity = isBusinessOpportunity;
            this.preferencesService.updateFilters(newFilters);
        }
    };
    HomePageComponent.prototype.updateCityPagesMetaItems = function (propType, totalListings, isOpenHouse) {
        if (propType) {
            this._setSEORelatedItems('popular-city-prop-type', { city: this.city, province: this.province, numberOfListings: totalListings, propType: propType });
        }
        else if (isOpenHouse) {
            this._setSEORelatedItems('open-houses-page', { city: this.city, province: this.province, numberOfListings: totalListings, propType: propType });
        }
        else {
            this._setSEORelatedItems('popular-city', { city: this.city, province: this.province, numberOfListings: totalListings });
        }
    };
    HomePageComponent.prototype._setH1Text = function (translationName, variables) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!variables) return [3 /*break*/, 3];
                        if (!variables['province']) return [3 /*break*/, 2];
                        _a = variables;
                        _b = 'province';
                        return [4 /*yield*/, this.translateService.get('provinces.' + variables['province']).toPromise()];
                    case 1:
                        _a[_b] = _c.sent();
                        _c.label = 2;
                    case 2:
                        if (variables['city'])
                            variables['city'] = variables['city'].charAt(0).toUpperCase() + variables['city'].slice(1);
                        if (variables['propType'])
                            variables['propType'] = variables['propType'].charAt(0).toUpperCase() + variables['propType'].slice(1);
                        _c.label = 3;
                    case 3:
                        this.translateService.get(translationName, variables).toPromise().then(function (description) { return _this.h1Text = description; });
                        return [2 /*return*/];
                }
            });
        });
    };
    HomePageComponent.prototype._getNewListingsSearch = function () {
        // Make sure to reset the previewed listings each time the filter changes
        this.previewedListings = [];
        this.logger.logDebug('homePageComponent', 'get listings requested');
        this.communicationService.notifications.notificationChanged.next(this.translateService.instant('notification.loading-listings'));
        this.isDoneFetchingListings = false;
        this.globalListingRequestZoom = this._userPositionInfo.zoomLevel;
        if (this.mapEnabled) {
            return this.listingsService.searchListingsMap(this.globalListingRequestZoom, this.isSuccessfulPhysicalLocation, this.screenSize >= SCREEN_SIZE.TABLET_LANDSCAPE_UP);
        }
        else {
            var pagination = new Pagination(this.startingPageNumber, 50);
            this.logger.logDebug('homePageComponent', 'Requesting listings for', this.city, 'results', pagination.offset, pagination.limit);
            return this.listingsService.searchProvinceCity(this.province, this.city, pagination);
        }
    };
    HomePageComponent.prototype._handleNewListingsSearch = function (res) {
        this.isDoneFetchingListings = true;
        if (this.mapEnabled) {
            // Browser rendered
            var listingResponse = res;
            if (listingResponse && listingResponse.results) {
                if (listingResponse.results.length > 0 && this.globalListingRequestZoom !== listingResponse.zoom) {
                    // We're about to change the zoom level on the user, so make sure we skip the next automatically triggered search when the map moves.
                    this.skipNextListingSearch = true;
                    this.communicationService.searching.updateMap.next({ zoom: listingResponse.zoom });
                }
                this.listingData = {
                    pins: listingResponse.results.map(function (l) {
                        var parts = l.split(';');
                        if (parts.length > 5) {
                            return new PinInfo({ lat: +parts[0], lng: +parts[1], listingId: parts[2], listPrice: +parts[3], listingDate: new Date(parts[4]), pricePerSqft: +parts[5] });
                        }
                    }),
                    positionInfo: listingResponse.position,
                    filterHash: listingResponse.filterHash
                };
                if (this.activeViewMode === ViewModes.GALLERY) {
                    this.sideGalleryPins = this.listingData.pins;
                }
                this.productSchema = this.listingsService.checkForProductValues(this.listingData.pins);
                this.notifyNewSearchTotals(res.totalHits);
            }
            this.isSearchingPhysicalLocation = false;
        }
        else {
            // Server rendered
            var listingPreviews = res;
            if (listingPreviews && listingPreviews.results) {
                this.logger.logDebug('homePageComponent', 'Got', listingPreviews.results.length, 'for', this.city);
                this.previewedListings = listingPreviews.results;
                this.notifyNewSearchTotals(listingPreviews.totalHits);
                this.productSchema = this.listingsService.checkForProductValues(listingPreviews.results);
            }
        }
    };
    HomePageComponent.prototype.notifyNewSearchTotals = function (totalHits) {
        this.communicationService.searchResultsAvailable.next(totalHits);
        this.communicationService.notifications.notificationChanged.next(this.translateService.instant('notification.n-listings-found', { n: totalHits }));
    };
    /**
     * Set Page description, title and h1 text
     */
    HomePageComponent.prototype._setSEORelatedItems = function (key, args) {
        this.metaTagsService.setPageDescription('meta-tags.' + key + '.description', args);
        this.metaTagsService.setPageTitle('meta-tags.' + key + '.title', args);
        this.metaTagsService.setOpenGraphTags([
            {
                name: 'title',
                content: 'meta-tags.' + key + '.title',
                variables: args,
                isTranslateKey: true
            },
            {
                name: 'description',
                content: 'meta-tags.' + key + '.description',
                variables: args,
                isTranslateKey: true
            }
        ]);
        this._setH1Text('meta-tags.' + key + '.h1', args);
    };
    /**
     * Setting SEO Related items for persona pages
     */
    HomePageComponent.prototype.setSEOForPersonas = function () {
        var _this = this;
        var key = '';
        if (this.personaType === PersonaType.EMPTY_NESTERS)
            key = 'our-right-sized-home';
        else if (this.personaType === PersonaType.FIRST_TIME_BUYER_COUPLE)
            key = 'first-time-buyer-couple';
        else if (this.personaType === PersonaType.FIRST_TIME_BUYER_SINGLE)
            key = 'first-time-buyer-single';
        else if (this.personaType === PersonaType.LUXURY)
            key = 'our-luxury-home';
        else if (this.personaType === PersonaType.MOVING_UP)
            key = 'our-next-home';
        else if (this.personaType === PersonaType.MULTI_GENERATIONAL_FAMILY)
            key = 'our-multi-family-home';
        // need to set a timeout here since the app.component resets all Open Graph Content on route changes and we need to make sure the reset happens first
        setTimeout(function () {
            _this._setSEORelatedItems(key, {});
        });
    };
    HomePageComponent.prototype.getFooterLinks = function () {
        var _this = this;
        this.addSub(this.internalLinksService.getLinks(this.province, this.city, this.currentShownListingType).subscribe(function (result) { return _this.footerLinks = result; }));
        var footerTitleObservable = [this.translateService.get('relevant-links.other-relevant-links')];
        if (this.province || this.city) {
            footerTitleObservable.push(this.translateService.get('relevant-links.for'), this.province ? this.translateService.get('provinces.' + this.province.toLowerCase()) : of(this.city));
        }
        this.addSub(forkJoin(footerTitleObservable).subscribe(function (titles) {
            _this.footerTitle = titles.join(' ');
        }));
    };
    HomePageComponent.prototype.setContext = function (data) {
        this.personaType = data.personaType;
        this.savedSearch = data.savedSearch;
        this.showNoSavedSearchFound = this.savedSearch === false;
        if (data.cityAndProvince)
            this._handlePopularCityAndPropPages(data.cityAndProvince);
        else if (data.propTypeAndCity)
            this._handlePopularCityAndPropPages(data.propTypeAndCity);
        else if (data.openHouse)
            this._handlePopularCityAndPropPages(data.openHouse);
        else if (data.businessOpportunity)
            this._handlePopularCityAndPropPages(data.businessOpportunity);
        else if (data.personaType !== undefined)
            this.setSEOForPersonas();
        else {
            // if there is an savedSearch object, restore saveSearch (filters, position)
            if (this.savedSearch)
                this.preferencesService.restoreSavedSearch(data.savedSearch);
            // Attempt to locate the user.
            this.preferencesService.centerMapAtCurrentLocation(!data.shouldCenterAtUserLocation);
            this.isSearchingPhysicalLocation = data.shouldCenterAtUserLocation;
            // After we've found their location the first time, we dont need to retrieve their position everytime they load the page now
            this.communicationService.searching.shouldCenterAtUserLocation.next(false);
        }
        if (this.personaType === PersonaType.LUXURY) {
            this.communicationService.setCurrentListingType(ListingCategory.LUXURY, false);
        }
    };
    return HomePageComponent;
}(HasSubscriptions));
export { HomePageComponent };
